import useSWR from 'swr'
import { ConversationService } from '@forwardflow/services/ConversationService'
import { PaginationQueryParams } from '@forwardflow/types'
import { Lead } from '@forwardflow/services/LeadService'

export const useGetRecentConversations = (
   queryParams: PaginationQueryParams
) => {
   const fetcher = () => ConversationService.getRecentConversations(queryParams)

   const {
      data: leads,
      error,
      mutate,
      isValidating,
   } = useSWR(['recent-conversations', queryParams], fetcher, {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
   })

   return {
      leads: leads as Lead[],
      loading: isValidating,
      error: error?.message || null,
      hasMore: (leads || []).length === queryParams.limit,
      mutate,
   }
}
